import * as React from 'react'

import './styles.sass'

function Label({ type = 'checked', text }) {
  return <div ><span className={`pvt-label custom pvt-label-${type}`}>{text}</span></div>
}

export default Label
